<template>
<profile-layout>
  <template slot="sidebar">
    <sidebar-modal :title="sidebarTitle"
      :active.sync="isSidebarActive"
      :button="sidebarButton"
      :loading="sidebarLoading"
      :destructive="sidebarDestructiveButton"
      :destroyLoading="sidebarDestroyLoading"
      :message.sync="sidebarMessage"
      :error.sync="sidebarError"
      v-on:action="onSidebarAction"
      v-on:destroy="onSidebarDestroy">
      <component v-bind:is="sidebarComponent"></component>
    </sidebar-modal>
  </template>
  <template slot="left">
    <div class="section">
      <user-details-card :user="user"
                         :coverPictureUrl="coverPictureUrl"
                         v-on:edit-profile="onEditProfile"
                         :editable="true" />
    </div>
    <div class="section">
      <external-profile-section @add="onAddExternalProfiles"></external-profile-section>
    </div>
    <div class="section">
      <hired-referrals-section />
    </div>
  </template>
  <template slot="right">
    <div class="referrer-card is-fixed">
      <ReferrerActionCard :user="user" />
    </div>
  </template>
</profile-layout>
</template>

<script>
import ProfileLayout from '@/templates/profile-layout'
import UserDetailsCard from '@/components/profile/user-details-card'
import SidebarModal from '@/components/sidebar-modal'
import EditProfile from '@/components/profile/edit-profile'
import ExternalProfileSection from '@/components/profile/profiles/profile-section'
import AddExternalProfiles from '@/components/profile/profiles/add-profile'
import HiredReferralsSection from '@/components/profile/referrer/hired-referrals-section'
import ReferrerActionCard from '@/components/profile/referrer/referrer-action-card'
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'

export default {
  components: {
    UserDetailsCard,
    SidebarModal,
    EditProfile,
    ProfileLayout,
    ExternalProfileSection,
    AddExternalProfiles,
    HiredReferralsSection,
    ReferrerActionCard
  },
  methods: {
    ...mapActions('users', [
      'getUser',
      'updateUser',
      'createOrUpdateSocialProfiles',
      'getUserProfiles'
    ]),
    ...mapActions('profileForm', [
      'loadWithUser'
    ]),
    ...mapMutations('profileForm', [
      'setFirstNameError', 'setLastNameError', 'setCompanyNameError'
    ]),
    validations () {
      if (this.firstName.length === 0) {
        this.setFirstNameError(this.$t('profile.firstNameRequired'))
        return false
      } else if (this.lastName.length === 0) {
        this.setLastNameError(this.$t('profile.lastNameRequired'))
        return false
      } else if (this.companyName.length === 0) {
        this.setCompanyNameError(this.$t('profile.companyNameRequired'))
        return false
      }
      return true
    },
    async onSidebarAction () {
      switch (this.sidebarComponent) {
        case 'EditProfile': {
          const validations = this.validations()
          if (!validations) {
            return false
          }
          this.sidebarLoading = true
          const data = this.profileFormData
          try {
            await this.updateUser(data)
            this.loadWithUser(this.user)
            this.isSidebarActive = false
          } catch (error) {
            this.sidebarError = error.message
          }
          this.sidebarLoading = false
          break
        }
        case 'AddExternalProfiles': {
          this.sidebarLoading = true
          try {
            await this.createOrUpdateSocialProfiles()
            this.sidebarMessage = this.$t('profile.savedSuccessfully')
          } catch (err) {
            this.sidebarError = err.message
          }
          this.sidebarLoading = false
          break
        }
        default:
          break
      }
    },
    async onSidebarDestroy () {
    },
    onEditProfile () {
      this.$ga.event('Profile', 'Edit Profile Clicked')
      this.sidebarDestructiveButton = null
      this.sidebarComponent = 'EditProfile'
      this.sidebarTitle = this.$t('profile.editProfile')
      this.sidebarButton = this.$t('profile.saveProfile')
      this.isSidebarActive = true
    },
    onAddExternalProfiles () {
      this.$ga.event('Profile', 'Add Social Profiles Clicked')
      this.sidebarDestructiveButton = null
      this.sidebarButton = this.$t('profile.saveSocialProfiles')
      this.sidebarTitle = this.$t('profile.socialProfiles')
      this.sidebarComponent = 'AddExternalProfiles'
      this.isSidebarActive = true
    }
  },
  computed: {
    ...mapGetters('users', [
      'coverPictureUrl',
      'user',
      'fullName'
    ]),
    ...mapGetters('profileForm', {
      profileFormData: 'formData'
    }),
    ...mapState('profileForm', [
      'firstName', 'lastName', 'companyName'
    ])
  },
  data () {
    return {
      sidebarTitle: '',
      isSidebarActive: false,
      sidebarComponent: '',
      sidebarButton: null,
      sidebarLoading: false,
      sidebarDestructiveButton: null,
      sidebarDestroyLoading: false,
      showBanner: false,
      sidebarMessage: null,
      sidebarError: null
    }
  },
  async mounted () {
    await this.getUser()
    this.$store.dispatch('users/getUserProfiles', this.user.id)
  }
}
</script>

<style lang="scss" scoped>

div.section:first-child {
  padding: 0;
}

div.section {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-top: 2.5rem;
}

.card {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/profiles/referrer-profile.vue